import React, { ChangeEvent, useState } from 'react'
import { InputGroupPropsTypes } from './InputGroupType'
import { FormIconDataPicker } from '../iconSet/IconSet'
import { type } from 'os'

const InputGroup = (props: InputGroupPropsTypes) => {

    const [singleCheckStatus, setSingleCheckStatus] = useState<boolean>(false)

    const handleSingleCheckClick = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked)
        {
            setSingleCheckStatus(true)   
        }
        else
        {
            setSingleCheckStatus(false)
        }
    }

    return (
        <div className={`input-group`} style={{visibility: props.notVisible ? 'hidden' : 'visible'}}>
            {props.label && (
                <span className={`label`}>{props.label} {props.required && <span>*</span>}</span>
            )}
            <div className={`field-wrapper`}>
                {props.type === "checkbox-single" ? (
                    <i style={{backgroundColor: props.color}}>
                        <input type="checkbox" name={props.name} id={props.name} ref={props.componentInputElement} onChange={(e) => {
                            handleSingleCheckClick(e)
                            props.onChange?.(e)
                        }}/>
                        <span className="custom-checkbox"></span>
                    </i>
                ) : (
                    <i style={{backgroundColor: props.color}}>{props.icon}</i>
                )}
                
                {/* Text box */}
                {props.type === 'text' && (
                    <input id={props.id} type="text" style={{borderRadius: props.dataPicker ? `0 0 0 0` : `0 0.5rem 0.5rem 0`}} placeholder={props.placeholder} ref={props.componentInputElement} disabled={props.disabled} onChange={props.onChange} onBlur={props.onBlur} name={props.name} value={props.value}/>
                )}
                {/* Drop box */}
                {props.type === 'select' && (
                    <select defaultValue={''} name={props.name} id="" ref={props.componentSelectElement} disabled={props.disabled} onChange={props.onChange} hidden={props.hidden}>
                        {props.placeholder && <option value='' disabled>{props.placeholder}</option>}
                        {props.optionList && (
                            props.optionList.map((item, index) => (
                            <option key={index} value={item.value}>{item.name}</option>
                        )
                        ))}
                    </select>
                )}
                {props.type === 'select-2' && (
                    <select value={props.value} name={props.name} id="" ref={props.componentSelectElement} disabled={props.disabled} onChange={props.onChange} hidden={props.hidden}>
                        {props.placeholder && <option value='' disabled>{props.placeholder}</option>}
                        {props.optionList && (
                            props.optionList.map((item, index) => (
                            <option key={index} value={item.value}>{item.name}</option>
                        )
                        ))}
                    </select>
                )}
                {/* Text area */}
                {props.type === 'text-area' && (
                    <textarea rows={7} cols={64} placeholder={props.placeholder} ref={props.componentTextArea} value={props.value} disabled={props.disabled} /* onChange={props.onChange}  */name={props.name} onChange={props.onChange}></textarea>
                )}
                {/* Number */}
                {props.type === 'number' && (
                    <input id={props.id} type="number" style={{borderRadius: props.dataPicker ? `0 0 0 0` : `0 0.5rem 0.5rem 0`}} placeholder={props.placeholder} ref={props.componentInputElement} disabled={props.disabled} onChange={props.onChange} name={props.name} min={props.min}/>
                )}
                {/* Number */}
                {props.type === 'password' && (
                    <input id={props.id} type="password" style={{borderRadius: props.dataPicker ? `0 0 0 0` : `0 0.5rem 0.5rem 0`}} placeholder={props.placeholder} ref={props.componentInputElement} disabled={props.disabled} onChange={props.onChange} name={props.name}/>
                )}
                {/* Date time */}
                {props.type === 'date-time' && (
                    <input id={props.id} type="datetime-local" style={{borderRadius: props.dataPicker ? `0 0 0 0` : `0 0.5rem 0.5rem 0`}} value={props.value} placeholder={props.placeholder} ref={props.componentInputElement} disabled={props.disabled} onChange={props.onChange} name={props.name}/>
                )}
                {props.dataPicker && props.setIsDataPickerOpen && (
                    <div className='data-picker-wrapper' onClick={(e) => props.setIsDataPickerOpen?.(true)}>
                        <FormIconDataPicker width='1rem' color='var(--color-text)'/>
                    </div>
                )}
                {/* {props.type === 'multi-selector' && (
                    <select multiple value={props.value} name={props.name} id="" ref={props.componentSelectElement} disabled={props.disabled} onChange={props.onChange}>
                        <option value='' disabled>{props.placeholder}</option>
                        {props.optionList && (
                            props.optionList.map((item, index) => (
                            <option key={index} value={item.value}>{item.name}</option>
                        )
                        ))}
                    </select>
                )} */}
                {props.type === 'multi-selector' && props.multiData && props.onClick && (
                    <div className='multi-selector' onClick={props.onClick}>
                        {props.multiData.length === 0 ? (
                            <span>{props.placeholder}</span>
                        ) : (
                            props.multiData.map((role, index) => (
                                <span key={index}>{role.name},</span>
                            ))
                        )}
                        
                    </div>
                )}

                {props.type === 'checkbox-single' && (
                    <div className="checkbox-single">
                        <span>{props.placeholder} - ({singleCheckStatus ? 'country' : 'area specific'})</span>
                    </div>
                )}
            </div>
        </div>
    )
}

export default InputGroup